module.exports = __webpack_public_path__ + "img/login.e2555c6e.jpg";